// extracted by mini-css-extract-plugin
export const title = "home-module--title--2fwWS";
export const section = "home-module--section--1b8UC";
export const invertedSection = "home-module--invertedSection--Dossr";
export const titleInverted = "home-module--titleInverted--28JOL";
export const button = "home-module--button--1auY6";
export const navTrigger = "home-module--navTrigger--39tAs";
export const homeSection = "home-module--homeSection--3JAu8";
export const homeContent = "home-module--homeContent--2BuBg";
export const active = "home-module--active--9IEdQ";
export const workSection = "home-module--workSection--2ktdU";
export const worksGrid = "home-module--worksGrid--1fqUx";
export const workItem = "home-module--workItem--LBiA_";
export const workInfo = "home-module--workInfo--3F0M9";
export const learnMoreBlock = "home-module--learnMoreBlock--WYHry";
export const workImg = "home-module--workImg---TbkZ";
export const aboutSection = "home-module--aboutSection--Gw-MZ";
export const aboutBlock = "home-module--aboutBlock--s4cAN";
export const aboutPhoto = "home-module--aboutPhoto--eZO00";
export const aboutText = "home-module--aboutText--3QOfS";
export const aboutSkills = "home-module--aboutSkills--15d7n";
export const aboutListSkills = "home-module--aboutListSkills--2sndQ";
export const skillLogo = "home-module--skillLogo--2a3D-";
export const contactSection = "home-module--contactSection--M9LOA";
export const contactForm = "home-module--contactForm--3_5yj";
export const nameField = "home-module--nameField--1ETW3";
export const emailField = "home-module--emailField--18I9_";
export const messageField = "home-module--messageField--wqNMI";